import { IsOptional, IsString } from "class-validator";
import { Expose } from "class-transformer";

export class UpdateBuildProjectDto {
  @Expose()
  @IsOptional()
  @IsString()
  proFacingNotes?: string | null;
}
